import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { UpdatePruebaTestimonialRequest } from '@models/pruebas/pruebaTestimonial/updatePruebaTestimonialRequest.model';
import { CreatePruebaTestimonialRequest } from '@models/pruebas/pruebaTestimonial/createPruebaTestimonialRequest.model';
import { PruebaTestimonialFilter } from '@models/pruebas/pruebaTestimonial/pruebaTestimonailFilter.model';
import { PruebaTestimonialDto } from '@models/pruebas/pruebaTestimonial/pruebaTestimonialDto.model';

@Injectable({
  providedIn: 'root'
})
export class PruebaTestimonialService {

  constructor(private http:HttpClient) {
  }

  create(createPruebaTestimonialRequest:CreatePruebaTestimonialRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/PruebaTestimonial/Create",createPruebaTestimonialRequest);
  }

  update(updatePruebaTestimonialRequest:UpdatePruebaTestimonialRequest):Observable<any>
  {
    return  this.http.put<any>("/api/PruebaTestimonial/Update",updatePruebaTestimonialRequest);
  }

  getAll():Observable<PruebaTestimonialDto[]> {
    return   this.http.get<PruebaTestimonialDto[]>("/api/PruebaTestimonial/GetAll");
  }

  getAllByIdExpediente(idExpediente:number):Observable<PruebaTestimonialDto[]> {
    return   this.http.get<PruebaTestimonialDto[]>("/api/PruebaTestimonial/GetAllByIdExpediente?idExpediente="+idExpediente);
  }

  getAllByFilter(pruebaTestimonialFilter: PruebaTestimonialFilter):Observable<PruebaTestimonialDto[]> {
    return   this.http.post<PruebaTestimonialDto[]>("/api/PruebaTestimonial/GetAllByFilter",pruebaTestimonialFilter);
  }


  getById(id:number):Observable<PruebaTestimonialDto>{
    return  this.http.get<PruebaTestimonialDto>("/api/PruebaTestimonial/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/PruebaTestimonial/Delete?id=" + id);
    else
      return of(null)
  }

  // Utility methods
  getMedioRegistroSugeridos(): string[] {
    return [
      'Audio',
      'Video',
      'Escrito',
      'Audio y Video',
      'Declaración Jurada',
      'Testimonio Oral',
      'Acta Notarial',
      'Grabación Digital'
    ];
  }

}
